import { faker } from '@faker-js/faker';

import type { ToggleDividendsReinvestPostResponse } from '../types/ToggleDividendsReinvestPostResponse';

export function createToggleDividendsReinvestPostResponse(
  data: NonNullable<Partial<ToggleDividendsReinvestPostResponse>> = {}
): NonNullable<ToggleDividendsReinvestPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
